const drawer = [
  {
    icon: 'mdi-home-outline',
    text: ('pages.home'),
    name: 'Home',
    to: '/',
    roles: [],
    permission: { act: "read", on: "Company" },
  },
  {
    icon: 'mdi-ruler-square-compass',
    text: ('pages.projects'),
    name: 'Projects',
    to: '/projects',
    roles: [],
    permission: { act: "read", on: "Project" },
  },
  {
    icon: 'mdi-account-outline',
    text: ('pages.clients'),
    name: 'Client',
    to: '/clients',
    roles: [],
    permission: { act: "read", on: "Client" },
  },
  {
    icon: 'mdi-account-group-outline',
    text: ('pages.employees'),
    name: 'Employees',
    to: '/employees',
    roles: [],
    permission: { act: "read", on: "Employee" },
  },

  {
    icon: 'mdi-check-circle-outline',
    text: ('pages.tasks'),
    name: 'Tasks',
    to: '/tasks',
    roles: [],
    permission: { act: "read", on: "Task" },
  },

  {
    icon: 'mdi-calendar',
    text: ('pages.agenda'),
    name: 'Agenda',
    to: '/agenda',
    roles: [],
    permission: { act: "read", on: "Task" },
  },
  {
    icon: 'mdi-file-outline',
    text: ('pages.templates'),
    name: 'Templates',
    to: '/templates',
    roles: [],
    permission: { act: "read", on: "Project" },
  },

  {
    icon: 'mdi-currency-usd',
    text: ('pages.financials'),
    name: 'Movements',
    to: '/movements',
    roles: [],
    permission: { act: "read", on: "Movement" },
  },
  {
    icon: 'mdi-folder-outline',
    text: ('pages.documents'),
    name: 'Documents',
    to: '/documents',
    roles: [],
    permission: { act: "read", on: "Document" },
  },

  {
    icon: 'mdi-shield-outline',
    text: ('pages.admin'),
    name: 'Companies',
    to: '/admin/companies',
    roles: ['super_admin', 'sys_admin'],
    permission: { act: "update", on: "Company" },
  },


  {
    //logout
    icon: 'mdi-logout',
    text: ('pages.logout'),
    name: 'Logout',
    to: '/logout',
    roles: [],
    permission: null,
  }
];

// const internal_registrations_tree = [
//   {
//     icon: 'mdi-store-cog',
//     text:(''),
//     name: '',
//     to: '/',
//     roles: [],
// permission: { act: "read", on: "DoneForm" },
//   },
// ]

const header_flow = []


export { header_flow, drawer };